module.exports = __webpack_public_path__ + "static/agegate-4f15831c41eaa296ce5f4e0923e72332.png";